import { useQuery } from '@tanstack/react-query';

import { getOnePageData } from '@/entities/page';

import { adaptProductOne } from './adapters';

export const onePageQueryKeys = {
  all: ['page-content-one'] as const,
  page: (slug?: string) =>
    [...onePageQueryKeys.all, 'page-content-one', slug] as const,
};

export const useOnePageData = (params: { slug: string }) => {
  return useQuery({
    queryKey: onePageQueryKeys.page(params.slug),
    queryFn: async () => {
      const data = await getOnePageData(params);
      return adaptProductOne(data);
    },
  });
};
